import { Route, Routes } from "react-router"
import { RoutePaths } from "../../routes"
import Layout from "../Layout/Layout"
import HomePage from "../../pages/HomePage"
import NewsPage from "../../pages/NewsPage"
import RulesPage from "../../pages/RulesPage"
import SovetPage from "../../pages/SovetPage"
import PolicyPage from "../../pages/PolicyPage"
import ContactsPage from "../../pages/ContactsPage"
import CurrentNewsPage from "../../pages/CurrentNewsPage"
import FaqPage from "../../pages/FaqPage"
import FeedbackPage from "../../pages/FeedbackPage"
import TestPage from "../../pages/TestPage"


const AppRouter = () => {
    return (
        <Routes>
            <Route path={RoutePaths.HOME} element={<Layout />}>
                <Route path={RoutePaths.HOME} element={<HomePage />} />
                <Route path={RoutePaths.NEWS} element={<NewsPage />} />
                <Route path={RoutePaths.CURRENT_NEWS} element={<CurrentNewsPage />} />
                <Route path={RoutePaths.RULES} element={<RulesPage />} />
                <Route path={RoutePaths.OB_SOVET} element={<SovetPage />} />
                <Route path={RoutePaths.POLICY} element={<PolicyPage />} />
                <Route path={RoutePaths.CONTACTS} element={<ContactsPage />} />
                <Route path={RoutePaths.SUPPORT} element={<FaqPage />} />
                <Route path={RoutePaths.FEEDBACK} element={<FeedbackPage />} />
                <Route path={RoutePaths.TEST} element={<TestPage/>} />
            </Route>
        </Routes>
    )
}

export default AppRouter